const settings = {
  baseUrl: 'https://www.dtm.com',
  nodeApi: {
    uri: 'https://api.dtm.com/' // https://pl7uybf77e.execute-api.eu-central-1.amazonaws.com/prod/'
  },
  LIFETIME_DEFAULT: 600000,
  LIFETIME_STATIC: 1800000,
  LIFETIME_SHORT: 60000
};
export default settings;
